import { useEffect, useState } from 'react';
import { getCookie } from './login';

export const useWindowWidth = header => {
	let range = header ? 1213 : 1024;
	const [isNarrow, setIsNarrow] = useState(window.innerWidth <= range);

	useEffect(() => {
		const handleResize = () => {
			setIsNarrow(window.innerWidth <= range);
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return isNarrow;
};

export const chkMobile = () => {
	try {
		// Chrome DevTools의 Device Toolbar 활성화 여부 체크
		const isEmulated =
			/Android|Mobile/.test(navigator.userAgent) && navigator.platform === 'MacIntel';

		// 기본 정보 수집 (에뮬레이션 중이면 실제 정보 사용)
		const deviceInfo = {
			userAgent: isEmulated ? 'MacIntel' : navigator.userAgent || '',
			platform: navigator.platform || '',
			maxTouchPoints: navigator.maxTouchPoints || 0,
			vendor: navigator.vendor || '',
			screenWidth: window.innerWidth || 0,
			screenHeight: window.innerHeight || 0,
		};

		// Intel Mac 체크
		const isIntelMac = () => {
			if (deviceInfo.platform !== 'MacIntel') return false;
			if (deviceInfo.maxTouchPoints > 1) return false;

			// Chrome DevTools 에뮬레이션 체크
			if (isEmulated) return true;

			const isDesktopBrowser =
				(/Chrome/.test(deviceInfo.userAgent) && /Google/.test(deviceInfo.vendor)) ||
				(/Safari/.test(deviceInfo.userAgent) && !/Chrome/.test(deviceInfo.userAgent)) ||
				/Firefox/.test(deviceInfo.userAgent);

			return isDesktopBrowser;
		};

		// 윈도우 데스크톱 체크
		const isWindowsDesktop = () => {
			return /Win32|Win64/i.test(deviceInfo.platform);
		};

		// 리눅스 데스크톱 체크
		const isLinuxDesktop = () => {
			return /Linux/i.test(deviceInfo.platform) && !/Android/.test(deviceInfo.userAgent);
		};

		// 데스크톱 여부 최종 판단
		const isDesktop = isIntelMac() || isWindowsDesktop() || isLinuxDesktop();

		// 디버깅용 로그
		// console.log('Device Detection Debug:', {
		// 	deviceInfo,
		// 	isEmulated,
		// 	isIntelMac: isIntelMac(),
		// 	isWindowsDesktop: isWindowsDesktop(),
		// 	isLinuxDesktop: isLinuxDesktop(),
		// 	isDesktop: isDesktop,
		// 	finalResult: !isDesktop,
		// });

		return !isDesktop;
	} catch (error) {
		// console.error('Device detection error:', error);
		return false;
	}
};

export const noneFilter = ['', null, undefined];

// 토큰 문자열 처리
export const toJavaScriptString = otherString => {
	return otherString.replace(/\\/gi, ' ').replace('"{', '{').replace('}"', '}').replace(/\s/gi, '');
};

// 토큰 유지 시간 확인
export const today_Date = () => {
	let date = new Date();
	let year = date.getFullYear().toString();
	let month = ('0' + (date.getMonth() + 1)).slice(-2);
	let day = ('0' + date.getDate()).slice(-2);
	let hour = ('0' + date.getHours()).slice(-2);
	let minute = ('0' + date.getMinutes()).slice(-2);
	let second = ('0' + date.getSeconds()).slice(-2);

	let returnDate = year + month + day + hour + minute + second;

	return returnDate;
};

// // 토큰 유지시간 확인
export const timeStamp = str => {
	if (str.toString().length == 10) {
		str = str * 1000;
	}

	let date = new Date(str);
	let year = date.getFullYear().toString();
	let month = ('0' + (date.getMonth() + 1)).slice(-2);
	let day = ('0' + date.getDate()).slice(-2);
	let hour = ('0' + date.getHours()).slice(-2);
	let minute = ('0' + date.getMinutes()).slice(-2);
	let second = ('0' + date.getSeconds()).slice(-2);

	let returnDate = year + month + day + hour + minute + second;

	return returnDate;
};

export const updateAccessTokenInCookie = (cookieValue, newAccessToken) => {
	// 쿠키 값을 URL 디코딩하여 파싱합니다.
	// const decodedCookie = decodeURIComponent(cookieValue);
	let cookieData = cookieValue;

	// accessToken 값을 업데이트합니다.
	cookieData.accessToken = newAccessToken;

	// 쿠키 값을 다시 인코딩하여 반환합니다.
	const updatedCookieValue = encodeURIComponent(JSON.stringify(cookieData));

	return '%22' + updatedCookieValue.replaceAll('%22', '%5C%22') + '%22';
};

export const generateTimeSlots = (startTime, endTime) => {
	// 시간을 분으로 변환하는 함수
	function timeToMinutes(time) {
		const [hours, minutes] = time.split(':').map(Number);
		return hours * 60 + minutes;
	}

	// 분을 시간 문자열로 변환하는 함수
	function minutesToTime(minutes) {
		const hours = String(Math.floor(minutes / 60)).padStart(2, '0');
		const mins = String(minutes % 60).padStart(2, '0');
		return `${hours}:${mins}`;
	}

	const start = timeToMinutes(startTime);
	const end = timeToMinutes(endTime);
	const timeSlots = [];

	for (let time = start; time <= end; time += 30) {
		timeSlots.push(minutesToTime(time));
	}

	return timeSlots;
};

export const generateTimeSlotsTen = (startTime, endTime) => {
	// 시간을 분으로 변환하는 함수
	function timeToMinutes(time) {
		const [hours, minutes] = time.split(':').map(Number);
		return hours * 60 + minutes;
	}

	// 분을 시간 문자열로 변환하는 함수
	function minutesToTime(minutes) {
		const hours = String(Math.floor(minutes / 60)).padStart(2, '0');
		const mins = String(minutes % 60).padStart(2, '0');
		return `${hours}:${mins}`;
	}

	const start = timeToMinutes(startTime);
	const end = timeToMinutes(endTime);
	const timeSlots = [];

	for (let time = start; time <= end; time += 10) {
		timeSlots.push(minutesToTime(time));
	}

	return timeSlots;
};

export const getConvertMinutes = time => {
	time = time.replace(/ /g, '');
	var timeArray = time.split(':');
	var timeStamp = parseInt(timeArray[0]) * 60 + parseInt(timeArray[1]);
	return timeStamp;
};

export const getConvertMinutesTable = timeStr => {
	const [hours, minutes] = timeStr.split(':').map(Number);
	return hours * 60 + minutes;
};

export const getTimeString = minutes => {
	const hours = Math.floor(minutes / 60);
	const mins = minutes % 60;
	return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
};

// 토큰 가져오는 함수
export const getToken = () => {
	try {
		const cookieTypes = [{ name: 'ArcId.USER_INFO' }, { name: 'ArcId.USER_INFO.session' }];

		for (const cookieType of cookieTypes) {
			const cookieValue = getCookie(cookieType.name);

			if (!noneFilter.includes(cookieValue) && cookieValue) {
				try {
					const JObject = JSON.parse(cookieValue);
					if (JObject?.accessToken) {
						return JObject.accessToken;
					}
				} catch (e) {
					// console.error(`Error parsing cookie ${cookieType.name}:`, e);
					continue;
				}
			}
		}

		return null;
	} catch (e) {
		// console.error('Error in getToken:', e);
		return null;
	}
};

// 시간표 동적으로 생성
export const insertEmptyPrograms = (programs, firstStart, finalEndTime) => {
	const result = [];
	const timeFormat = 'HH:mm';

	// 시간을 분으로 변환하는 함수
	function timeToMinutes(time) {
		const [hours, minutes] = time.split(':').map(Number);
		return hours * 60 + minutes;
	}

	// 분을 시간으로 변환하는 함수
	function minutesToTime(minutes) {
		const hours = String(Math.floor(minutes / 60)).padStart(2, '0');
		const mins = String(minutes % 60).padStart(2, '0');
		return `${hours}:${mins}`;
	}

	// firstStart와 첫 프로그램 시작 시간 사이의 빈 시간 채우기
	const firstProgramStartTime = timeToMinutes(programs[0].startTime);
	let currentTime = timeToMinutes(firstStart);

	while (currentTime < firstProgramStartTime) {
		const nextTime = Math.min(currentTime + 30, firstProgramStartTime);
		result.push({
			programId: null,
			startTime: minutesToTime(currentTime),
			endTime: minutesToTime(nextTime),
			programName: '',
			programContent: '',
			programTrack: '',
			speakerInfoDtos: [],
		});
		currentTime = nextTime;
	}

	for (let i = 0; i < programs.length; i++) {
		const currentProgram = programs[i];
		result.push(currentProgram);

		const currentEndTime = timeToMinutes(currentProgram.endTime);
		const nextStartTime =
			i + 1 < programs.length
				? timeToMinutes(programs[i + 1].startTime)
				: timeToMinutes(finalEndTime);

		if (currentEndTime < nextStartTime) {
			let emptyStartTime = currentEndTime;

			while (emptyStartTime < nextStartTime) {
				const emptyEndTime = Math.min(emptyStartTime + 30, nextStartTime);
				if (emptyStartTime < emptyEndTime) {
					result.push({
						programId: null,
						startTime: minutesToTime(emptyStartTime),
						endTime: minutesToTime(emptyEndTime),
						programName: '',
						programContent: '',
						programTrack: '',
						speakerInfoDtos: [],
					});
					emptyStartTime = emptyEndTime;
				} else {
					break;
				}
			}
		}
	}

	// 마지막 빈 객체 추가
	const lastProgramEndTime = timeToMinutes(result[result.length - 1].endTime);
	const lastEndPlus30 = lastProgramEndTime + 30;
	result.push({
		programId: null,
		startTime: minutesToTime(lastProgramEndTime),
		endTime: minutesToTime(lastEndPlus30),
		programName: '',
		programContent: '',
		programTrack: '',
		speakerInfoDtos: [],
	});

	return result;
};

// 시간표 동적으로 생성
export const insertEmptyProgramsTen = (programs, firstStart, finalEndTime) => {
	const result = [];
	const timeFormat = 'HH:mm';

	// 시간을 분으로 변환하는 함수
	function timeToMinutes(time) {
		const [hours, minutes] = time.split(':').map(Number);
		return hours * 60 + minutes;
	}

	// 분을 시간으로 변환하는 함수
	function minutesToTime(minutes) {
		const hours = String(Math.floor(minutes / 60)).padStart(2, '0');
		const mins = String(minutes % 60).padStart(2, '0');
		return `${hours}:${mins}`;
	}

	// firstStart와 첫 프로그램 시작 시간 사이의 빈 시간 채우기
	const firstProgramStartTime = timeToMinutes(programs[0].startTime);
	let currentTime = timeToMinutes(firstStart);

	while (currentTime < firstProgramStartTime) {
		const nextTime = Math.min(currentTime + 10, firstProgramStartTime);
		result.push({
			programId: null,
			startTime: minutesToTime(currentTime),
			endTime: minutesToTime(nextTime),
			programName: '',
			programContent: '',
			programTrack: '',
			speakerInfoDtos: [],
		});
		currentTime = nextTime;
	}

	for (let i = 0; i < programs.length; i++) {
		const currentProgram = programs[i];
		result.push(currentProgram);

		const currentEndTime = timeToMinutes(currentProgram.endTime);
		const nextStartTime =
			i + 1 < programs.length
				? timeToMinutes(programs[i + 1].startTime)
				: timeToMinutes(finalEndTime);

		if (currentEndTime < nextStartTime) {
			let emptyStartTime = currentEndTime;

			while (emptyStartTime < nextStartTime) {
				const emptyEndTime = Math.min(emptyStartTime + 10, nextStartTime);
				if (emptyStartTime < emptyEndTime) {
					result.push({
						programId: null,
						startTime: minutesToTime(emptyStartTime),
						endTime: minutesToTime(emptyEndTime),
						programName: '',
						programContent: '',
						programTrack: '',
						speakerInfoDtos: [],
					});
					emptyStartTime = emptyEndTime;
				} else {
					break;
				}
			}
		}
	}

	// 마지막 빈 객체 추가
	const lastProgramEndTime = timeToMinutes(result[result.length - 1].endTime);
	const lastEndPlus30 = lastProgramEndTime + 10;
	result.push({
		programId: null,
		startTime: minutesToTime(lastProgramEndTime),
		endTime: minutesToTime(lastEndPlus30),
		programName: '',
		programContent: '',
		programTrack: '',
		speakerInfoDtos: [],
	});

	return result;
};

// 홀네임 동적으로 생성
export const getHallName = idx => {
	let name = '';
	if (idx === 0) {
		name = 'Dynasty';
	}
	if (idx === 1) {
		name = 'Emerald';
	}
	if (idx === 2) {
		name = 'Topaz';
	}
	if (idx === 3) {
		name = 'Ruby';
	}
	if (idx === 4) {
		name = 'Lilac';
	}
	if (idx === 5) {
		name = 'Orchid';
	}
	return name;
};

// 프로그램 페이지 날짜 반환하는 함수
export const formatProgramDate = dateStr => {
	// 날짜 문자열을 Date 객체로 변환
	const date = new Date(dateStr);

	// 월 이름 배열
	const monthNames = [
		'Jan',
		'Feb',
		'Mar',
		'Apr',
		'May',
		'Jun',
		'Jul',
		'Aug',
		'Sep',
		'Oct',
		'Nov',
		'Dec',
	];

	// 요일 이름 배열
	const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

	// 월, 일, 요일 가져오기
	const month = monthNames[date.getMonth()];
	const day = date.getDate();
	const dayName = dayNames[date.getDay()];

	// 원하는 형식으로 출력
	return `${month} ${day} (${dayName})`;
};

// 메인에서 날짜 변경하는 함수
export const formatMainDate = (dateStr, lang, type) => {
	// 날짜 문자열을 Date 객체로 변환
	const date = new Date(dateStr);

	// 월 이름 배열 (영어)
	const monthNamesEng = [
		'Jan',
		'Feb',
		'Mar',
		'Apr',
		'May',
		'Jun',
		'Jul',
		'Aug',
		'Sep',
		'Oct',
		'Nov',
		'Dec',
	];

	// 요일 이름 배열 (영어)
	const dayNamesEng = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

	// 요일 이름 배열 (한국어)
	const dayNamesKor = ['일', '월', '화', '수', '목', '금', '토'];

	// 월, 일, 요일 가져오기
	const year = date.getFullYear();
	const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 월을 2자리로 맞춤
	const day = date.getDate().toString().padStart(2, '0'); // 일을 2자리로 맞춤
	const dayNameEng = dayNamesEng[date.getDay()];
	const dayNameKor = dayNamesKor[date.getDay()];

	// type에 따라 연도 포함 여부 결정
	const datePrefix = type === 'start' ? `${year}.` : '';

	// 언어에 따라 형식 설정
	if (lang === 'en') {
		return `${datePrefix}${month}.${day} (${dayNameEng})`;
	} else if (lang === 'ko') {
		return `${datePrefix}${month}.${day}(${dayNameKor})`;
	} else {
		return "Invalid language parameter. Use 'eng' or 'kor'.";
	}
};

// 주민번호 정규식
export const isValidJumin = (num1, num2, gender) => {
	let registNum = num1 + num2;
	const regex = /^\d{2}(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])\d{7}$/;
	const TODAY_YEAR = new Date().getFullYear();
	const TODAY_YEAR_2DIGIT = TODAY_YEAR % 100;

	// 성별 코드 체크
	if (num2[0] === '0') {
		return false;
	}

	// 입력여부 체크
	if (num1.toString().length === 0) {
		return false;
	}

	if (num2.toString().length === 0) {
		return false;
	}

	// 입력값 체크
	if (num1.toString().match('[^0-9]')) {
		return false;
	}
	if (num2.toString().match('[^0-9]')) {
		return false;
	}

	// 길이 체크
	if (registNum.length !== 13) {
		return false;
	}

	// 연도와 성별 코드
	const yearNum = parseInt(registNum.slice(0, 2));
	const sexNum = registNum.slice(6);

	if (0 > Number(sexNum[0]) || 6 < Number(sexNum[0])) {
		return false;
	}

	// 연도 및 성별 검증 로직
	if (sexNum[0] === '1' || sexNum[0] === '2') {
		// 1900년대생: 남자는 1, 여자는 2만 허용
		if ((gender === 'M' && sexNum[0] !== '1') || (gender === 'W' && sexNum[0] !== '2')) {
			return false;
		}
	} else if (sexNum[0] === '3' || sexNum[0] === '4') {
		// 2000년대생: 남자는 3, 여자는 4만 허용
		if (yearNum > TODAY_YEAR_2DIGIT) {
			return false;
		}
		if ((gender === 'M' && sexNum[0] !== '3') || (gender === 'W' && sexNum[0] !== '4')) {
			return false;
		}
	} else if (sexNum[0] === '5' || sexNum[0] === '6') {
		// 1800년대생 (실제로는 사용 안 함)
		return false;
	}

	// 월과 일 검사
	if (regex.test(registNum) === false) {
		return false;
	}

	return true;
};

export const sortDate = (arr, order) => {
	return arr.sort((a, b) => {
		return order[a] - order[b];
	});
};

export const openingOrder = {
	'개회식(5월20일)': 1,
	'5월 20일': 2,
	'5월 21일': 3,
};

export const openingOrderUi = {
	'Opening Ceremony(20 May)': 1,
	'20May': 2,
	'21May': 3,
};

export const mealPartyOrder = {
	'5월20일오찬': 1,
	'5월20일만찬': 2,
	'5월21일오찬': 3,
};

export const mealPartyOrderUi = {
	'20 May Luncheon': 1,
	'20 May Dinner': 2,
	'21 May Luncheon': 3,
};

// 하이픈 넣는 정규식

export const autoHypenTel = num => {
	let string = '';
	if (num.length === 11) {
		string = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
	}
	if (num.length === 10) {
		string = num.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
	}
	return string;
};

//
export const passportSecurity = num => {
	if (typeof num !== 'string') return 'Invalid input';

	// 문자열이 비어있거나 1자 미만인 경우 처리
	if (!num || num.length < 1) return '';

	// 첫 글자 + '*'을 (길이-1)만큼 반복
	return num[0] + '*'.repeat(num.length - 1);
};

// 참가조회 결제상태
export const paymentStatus = (lang, payMethod, status) => {
	if (lang === 'en') {
		if (payMethod === 'draw') {
			if (status === '1') {
				return 'Waiting for payment';
			}
			if (status === '3') {
				return 'Registration completed';
			}
			if (status === '4') {
				return 'Waiting to cancel';
			}
			if (status === '5') {
				return 'Cancellation completed';
			}
		}
		if (payMethod === 'card') {
			if (status === '3') {
				return 'Registration completed';
			}
			if (status === '4') {
				return 'Waiting to cancel';
			}
			if (status === '5') {
				return 'Cancellation completed';
			}
		}
	}
	if (lang === 'ko') {
		if (payMethod === 'draw') {
			if (status === '1') {
				return '결제대기';
			}
			if (status === '3') {
				return '등록완료';
			}
			if (status === '4') {
				return '취소대기';
			}
			if (status === '5') {
				return '취소완료';
			}
		}
		if (payMethod === 'card') {
			if (status === '3') {
				return '등록완료';
			}
			if (status === '4') {
				return '취소대기';
			}
			if (status === '5') {
				return '취소완료';
			}
		}
	}
};

export const emailCheck = email_address => {
	let email_regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
	if (!email_regex.test(email_address)) {
		return false;
	} else {
		return true;
	}
};

export const foodChange = food => {
	if (food === '') {
		return '';
	}
	if (food === '해당없음' || food === 'N/A') {
		return '1';
	}
	if (food === '할랄' || food === 'Halal') {
		return '2';
	}
	if (food === '비건' || food === 'Vegan') {
		return '3';
	}
};

export const foodChangeReverse = (food, lang) => {
	if (lang === 'en') {
		if (food === '') {
			return;
		}
		if (food === '1') {
			return 'N/A';
		}
		if (food === '2') {
			return 'Halal';
		}
		if (food === '3') {
			return 'Vegan';
		}
	} else {
		if (food === '') {
			return;
		}
		if (food === '1') {
			return '해당없음';
		}
		if (food === '2') {
			return '할랄';
		}
		if (food === '3') {
			return '비건';
		}
	}
};

export const maskPhoneNumber = phone => {
	const numbers = phone?.replace(/\D/g, '') || '';

	// 한국 번호 처리 (010 시작, 11자리)
	if (numbers.startsWith('010') && numbers.length === 11) {
		return `${numbers.slice(0, 3)}-****-${numbers.slice(-4)}`;
	}

	// 한국 일반 번호 (10자리: 02, 031 등)
	if (numbers.length === 10) {
		return `${numbers.slice(0, 3)}-***-${numbers.slice(-4)}`;
	}

	// 한국 일반 번호 (9자리)
	if (numbers.length === 9) {
		return `${numbers.slice(0, 2)}-***-${numbers.slice(-4)}`;
	}

	// 국외 번호 처리 (8자리 이상)
	if (numbers.length > 8) {
		const lastDigits = numbers.slice(-4);
		const firstDigits = numbers.slice(0, 2);
		const middleLength = numbers.length - 6;

		return `${firstDigits}-${'*'.repeat(Math.min(middleLength, 6))}-${lastDigits}`;
	}

	// 짧은 번호 (8자리 이하)
	if (numbers.length >= 4) {
		const lastDigits = numbers.slice(-4);
		const firstPart = numbers.slice(0, -4);
		return `${firstPart}-****`.replace(/^-/, '');
	}

	// 처리할 수 없는 경우 원본 반환
	return phone;
};

export const maskNationPhoneNumber = phone => {
	const numbers = phone?.replace(/\D/g, '') || '';

	// 한국 번호 처리 (+82 또는 010 시작)
	if (numbers.startsWith('82')) {
		// 82 다음의 0을 제거하고 새로운 0 추가
		let cleanNumber = numbers.slice(2); // "01012345678"

		// 만약 0으로 시작하면 그대로, 아니면 0 추가
		if (!cleanNumber.startsWith('0')) {
			cleanNumber = '0' + cleanNumber;
		}

		if (cleanNumber.length === 11) {
			return `${cleanNumber.slice(0, 3)}-****-${cleanNumber.slice(-4)}`;
		}
	} else if (numbers.startsWith('010') && numbers.length === 11) {
		return `${numbers.slice(0, 3)}-****-${numbers.slice(-4)}`;
	}

	// 국외 번호 처리 (국가코드 제거 + 중간 마스킹)
	if (numbers.length > 8) {
		// 국가코드 제거하고 마지막 4자리만 표시
		const lastDigits = numbers.slice(-4);
		const middleLength = numbers.length - 4;

		return `${'*'.repeat(Math.min(middleLength, 8))}-${lastDigits}`;
	}

	// 처리할 수 없는 경우 원본 반환
	return phone;
};

export const formatNumber = num => {
	if (!num && num !== 0) return '';
	return Number(num).toLocaleString('ko-KR');
};

export const payStatus = status => {
	switch (status) {
		case '0': {
			return '등록전';
		}

		case '1': {
			return '결제대기';
		}

		case '2': {
			return '등록대기';
		}

		case '3': {
			return '등록완료';
		}

		case '4': {
			return '취소대기';
		}

		case '5': {
			return '취소완료';
		}

		case '6': {
			return '등록 중';
		}

		default:
			console.warn('알 수 없는 상태:', status);
	}
};

export const departmentText = (lang, departmentEn, departmentKr) => {
	if (lang === 'en') {
		return departmentEn || '-';
	}

	if (!departmentKr && !departmentEn) return '-';
	if (!departmentKr) return departmentEn;
	if (!departmentEn) return departmentKr;
	return `${departmentKr}(${departmentEn})`;
};

export const maskResidentNumber = residentNumber => {
	if (!residentNumber) return '';

	const cleaned = residentNumber.replace(/-/g, '');

	if (cleaned.length !== 13) return residentNumber;

	return `${cleaned.slice(0, 6)}-${'*'.repeat(7)}`;
};
